@if (titlesList && titlesList.length > 0) {
<div #summary class="summary">
  <div class="header" (click)="collapse()">
    <h2>Table des matières</h2>
    <h2>{{ collapsed ? '+' : '-' }}</h2>
  </div>
  <ul class="main-ul" [@summaryAnimation]="collapsed ? 'collapse' : 'expand'" #mainUl>
    @for (title of titlesList; track title.id) {
    <li>
      <div class="title-container main-title">
        <a (click)="scrollToAnchor(title.id)">
          <app-inner-html styleClass="main-title" [content]="title.title"></app-inner-html>
        </a>
      </div>
      @if (title.subTitles) {
      <ul>
        @for (sTitle of title.subTitles; track sTitle.id) {
        <li class="secondary-title">
          <div class="title-container">
            <a (click)="scrollToAnchor(sTitle.id)"
              ><app-inner-html [content]="sTitle.title"></app-inner-html
            ></a>
          </div>
        </li>
        }
      </ul>
      }
    </li>
    }
  </ul>
</div>
}
